import {Messages} from "../Messages.js";
import {BlinkGlobal} from "../UtilsLib.js";

// TODO @mustfix remove this
export function getPaymentMethodEmptySubscriptionMessage(subscription) {
    return (!subscription.billedUserId || subscription.billedUserId === BlinkGlobal.userId) ?
        Messages.noPaymentMethodForThisSubscription :
        Messages.noPaymentMethodForThisSubscriptionGifted;
}
